/*
 * Copyright (c) 2024.
 * The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 *
 */

import React, {useEffect, useState} from "react";
import {useTypedSelector} from "helpers/reducers";
import {useTranslation} from "react-i18next";
import CardComponent from "pages/Front/Booking/components/CardComponent";
import Loader from "components/Loader";
import {translate} from "utils/utility";
import {Payment} from "types/entities/Payment";
import {ArticleTicketType} from "types/enums/ArticleTicketType";
import {DEFAULT_HALL} from "helpers/config";
import {HallCode} from "types/enums/HallCode";

const BookingPaidTickets = () => {
    const hall = useTypedSelector(state => state.hallState.hall);
    const payment = useTypedSelector(state => state.bookingState.bookingProcess.payment);
    const {t} = useTranslation();
    const [result, setResult] = useState<Payment | null>(null);

    useEffect(() => {
        if (payment) {
            setResult(payment);
        }
    }, [payment]);
    if (!hall || !result) {
        return <Loader />;
    }
    return (
        <div className={"PaymentTickets grid sm:grid-cols-2 gap-4 sm:gap-8 sm:justify-between items-center px-4 sm:px-12"}>
            {result.tickets &&
                result.tickets
                    .filter(ticket => {
                        if (!ticket.article) {
                            return true;
                        }
                        return ticket.article.ticket_type === ArticleTicketType.Race;
                    })
                    .map(ticket => {
                        return (
                            <CardComponent key={ticket.id} className={"flex-grow text-sm sm:text-lg"}>
                                <div className={"flex flex-col justify-center items-center p-4 rounded-md space-y-2 sm:space-y-8"}>
                                    <div className={"bg-secondary-100 px-2 py-1 rounded-md"}>
                                        {t("Ticket")} - {ticket.article?.race_count_total} {t("point_count", {count: ticket.article?.race_count_total})}
                                    </div>
                                    <span>
                                        {ticket.article ? translate(ticket.article.article_name) : ""} - {t(ticket.person_type)}
                                    </span>
                                    <img alt={"ticket QR code"} className={"w-[120px] h-[120px]"} src={ticket.qr ? ticket.qr : ""} />
                                    <a
                                        className={"px-3 py-2 rounded-md bg-primary-800 text-white"}
                                        href={ticket.pdf ? ticket.pdf : ""}
                                        rel="noopener noreferrer"
                                        target="_blank"
                                        download
                                    >
                                        {t("Download")}
                                    </a>
                                    {DEFAULT_HALL !== HallCode.Zwolle && (
                                        <a
                                            className={"px-3 py-2 rounded-md bg-cta-800 text-white"}
                                            download={ticket.giftcard ? ticket.giftcard : ""}
                                            href={ticket.giftcard ? ticket.giftcard : ""}
                                            rel="noopener noreferrer"
                                            target="_blank"
                                        >
                                            {t("Download Gift Card")}
                                        </a>
                                    )}
                                </div>
                            </CardComponent>
                        );
                    })}
        </div>
    );
};

export default BookingPaidTickets;
